import React__default from 'react';
var TextVariant;
(function (TextVariant) {
  TextVariant["HEADING1"] = "heading1";
  TextVariant["HEADING2"] = "heading2";
  TextVariant["HEADING3"] = "heading3";
  TextVariant["HEADING4"] = "heading4";
  TextVariant["HEADING5"] = "heading5";
  TextVariant["HEADING6"] = "heading6";
  TextVariant["BODY1"] = "body1";
  TextVariant["BODY1_SEMIBOLD"] = "body1-semibold";
  TextVariant["BODY2"] = "body2";
  TextVariant["BODY3_SEMIBOLD"] = "body3-semibold";
  TextVariant["BODY3"] = "body3";
  TextVariant["BUTTON_LARGE"] = "button-large";
  TextVariant["BUTTON_MEDIUM"] = "button-medium";
  TextVariant["BUTTON_LINK_MEDIUM"] = "button-link-medium";
  TextVariant["BUTTON_LINK_SMALL"] = "button-link-small";
  TextVariant["MONOGRAM"] = "monogram";
})(TextVariant || (TextVariant = {}));
function HorizonText(_a) {
  var children = _a.children,
    inline = _a.inline,
    variant = _a.variant,
    _b = _a.className,
    className = _b === void 0 ? '' : _b,
    _c = _a.onClick,
    onClick = _c === void 0 ? function () {
      return null;
    } : _c;
  function onTextClick() {
    if (onClick) {
      onClick();
    }
  }
  function getVariantClass() {
    if (variant === TextVariant.HEADING1) {
      return 'text-h1';
    }
    if (variant === TextVariant.HEADING2) {
      return 'text-h2';
    }
    if (variant === TextVariant.HEADING3) {
      return 'text-h3';
    }
    if (variant === TextVariant.HEADING4) {
      return 'text-h4';
    }
    if (variant === TextVariant.HEADING5) {
      return 'text-h5';
    }
    if (variant === TextVariant.HEADING6) {
      return 'text-h6 uppercase';
    }
    if (variant === TextVariant.BODY1_SEMIBOLD) {
      return 'text-b1-semibold';
    }
    if (variant === TextVariant.BODY2) {
      return 'text-b2';
    }
    if (variant === TextVariant.BODY3_SEMIBOLD) {
      return 'text-b3-semibold';
    }
    if (variant === TextVariant.BODY3) {
      return 'text-b3';
    }
    if (variant === TextVariant.BUTTON_LARGE) {
      return 'text-btn-l inline';
    }
    if (variant === TextVariant.BUTTON_MEDIUM) {
      return 'text-btn-m inline';
    }
    if (variant === TextVariant.BUTTON_LINK_MEDIUM) {
      return 'text-btn-link-m inline';
    }
    if (variant === TextVariant.BUTTON_LINK_SMALL) {
      return 'text-btn-link-s inline';
    }
    if (variant === TextVariant.MONOGRAM) {
      return 'text-monogram uppercase';
    }
    return 'text-b1';
  }
  function getTextStructure() {
    var textClass = "".concat(getVariantClass(), " ").concat(className);
    if (inline) {
      return React__default.createElement("span", {
        onClick: onTextClick,
        className: "mr-1 ".concat(textClass)
      }, children);
    }
    if (variant === TextVariant.HEADING1) {
      return React__default.createElement("h1", {
        onClick: onTextClick,
        className: textClass
      }, children);
    }
    if (variant === TextVariant.HEADING2) {
      return React__default.createElement("h2", {
        onClick: onTextClick,
        className: textClass
      }, children);
    }
    if (variant === TextVariant.HEADING3) {
      return React__default.createElement("h3", {
        onClick: onTextClick,
        className: textClass
      }, children);
    }
    if (variant === TextVariant.HEADING4) {
      return React__default.createElement("h4", {
        onClick: onTextClick,
        className: textClass
      }, children);
    }
    if (variant === TextVariant.HEADING5) {
      return React__default.createElement("h5", {
        onClick: onTextClick,
        className: textClass
      }, children);
    }
    if (variant === TextVariant.HEADING6) {
      return React__default.createElement("h6", {
        onClick: onTextClick,
        className: textClass
      }, children);
    }
    return React__default.createElement("p", {
      onClick: onTextClick,
      className: textClass
    }, children);
  }
  return getTextStructure();
}
export { TextVariant, HorizonText as default };
//# sourceMappingURL=index.js.map
